import React, { useEffect, useState } from 'react';
import { WAITING_REASONS } from '../utils/taskWaiting';
import './TaskWaitingDialog.css';

const toLocalInput = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const pad = number => String(number).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

const TaskWaitingDialog = ({ task, onClose, onSave, saving = false }) => {
  const [reason, setReason] = useState('');
  const [comment, setComment] = useState('');
  const [remindAt, setRemindAt] = useState('');

  useEffect(() => {
    setReason(task?.waiting_reason || '');
    setComment(task?.waiting_comment || '');
    setRemindAt(toLocalInput(task?.waiting_until));
  }, [task]);

  useEffect(() => {
    if (!task) return undefined;
    const handleNativeBack = () => {
      if (!saving) onClose();
    };
    window.addEventListener('crm:native-back', handleNativeBack);
    return () => window.removeEventListener('crm:native-back', handleNativeBack);
  }, [onClose, saving, task]);

  if (!task) return null;
  const submit = (details = true) => onSave(details ? {
    reason: reason || null,
    comment: comment.trim() || null,
    remind_at: remindAt ? new Date(remindAt).toISOString() : null,
  } : {});

  return (
    <div className="waiting-dialog-backdrop" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <div className="waiting-dialog" role="dialog" aria-modal="true" aria-labelledby="waiting-title">
        <button type="button" className="waiting-dialog-close" onClick={onClose} aria-label="Закрыть">×</button>
        <div className="waiting-dialog-icon">⏸</div>
        <h2 id="waiting-title">Поставить в ожидание</h2>
        <p className="waiting-dialog-task">{task.title}</p>
        <p className="waiting-dialog-hint">Причину, комментарий и напоминание можно пропустить.</p>

        <label>Причина
          <select value={reason} onChange={(event) => setReason(event.target.value)}>
            {WAITING_REASONS.map(item => <option key={item.value} value={item.value}>{item.label}</option>)}
          </select>
        </label>
        <label>Комментарий
          <textarea value={comment} onChange={(event) => setComment(event.target.value)} rows={3} placeholder="Например: клиент обещал ответить после обеда" />
        </label>
        <label>Вернуть в работу и напомнить
          <input type="datetime-local" value={remindAt} onChange={(event) => setRemindAt(event.target.value)} />
        </label>

        <div className="waiting-dialog-actions">
          <button type="button" className="secondary" disabled={saving} onClick={() => submit(false)}>Без деталей</button>
          <button type="button" className="primary" disabled={saving} onClick={() => submit(true)}>
            {saving ? 'Сохраняю…' : 'Поставить в ожидание'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TaskWaitingDialog;
